import { getEmergencyData as n } from "./contact-channels41.js";
import { useQuery as o } from "./contact-channels42.js";
import { useContactChannelsContext as m } from "./contact-channels19.js";
const u = (e = !0) => {
  const { tenant: t, locale: r } = m();
  return o({
    queryKey: ["emergency"],
    queryFn: () => n(t, r),
    staleTime: 1 / 0,
    gcTime: 1 / 0,
    enabled: e,
    retry: 3
  });
};
export {
  u as useEmergencyCheck
};
//# sourceMappingURL=contact-channels2.js.map
